// extracted by mini-css-extract-plugin
export default {"scroll_block":"styles_scroll_block__8TRtS","scroll_block_no_background":"styles_scroll_block_no_background__Ap+Dl"};